import React, { FC, useEffect, useRef } from 'react';

import { useNavigate } from 'react-router-dom';
import { Box, IconButton } from '@mui/material';

import {
  ClientChatTypes,
  createChatFromProfessional,
  getProfessionalChannelUrl,
  pharmacistEvent,
  resetChatValues,
  setChatActiveTab,
  TypeOfUser,
} from '@pharmaplan/common';

import { ReactComponent as ChatIcon } from '../../../../../assets/svg/innerChatIcon.svg';
import { useAppSelector } from '../../../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../../../hooks/useAppDispatch';
import { Constants } from '../../../../../helpers/Constants';
import WithSkeleton from '../../../../common/WithSkeleton';

import styles from './styles';

interface IGoToPharmacyChat {
  successAction: string;
}

const GoToPharmacyChat: FC<IGoToPharmacyChat> = ({ successAction }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const createRef = useRef(false);

  const url = useAppSelector(getProfessionalChannelUrl);
  const event = useAppSelector(pharmacistEvent);

  const { pharmacyId, pharmacyName } = event ?? {};

  const createChat = () => {
    dispatch(createChatFromProfessional(pharmacyId));
    createRef.current = true;
  };

  const goToChat = () => {
    dispatch(setChatActiveTab(ClientChatTypes.pharmacy));
    navigate(Constants.paths.chat, {
      state: {
        personnelId: pharmacyId,
        url,
        channelName: `${pharmacyName} / `,
        userType: TypeOfUser.pharmacy,
      },
    });
  };

  const SkeletonBox = WithSkeleton({
    successAction,
    variant: 'circular',
  })(Box);

  useEffect(() => {
    if (url && createRef.current) {
      dispatch(resetChatValues(['professionalChannelUrl']));
      goToChat();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  return (
    <Box sx={styles.container}>
      <SkeletonBox>
        <IconButton sx={styles.chatIcon} onClick={createChat}>
          <ChatIcon />
        </IconButton>
      </SkeletonBox>
    </Box>
  );
};

export default GoToPharmacyChat;
